import { getCookieClient } from '../utils/storage/utils'
import { COHORT_COOKIE } from '../openfeature/utils'
import debug from '../utils/console'

const logger = debug.withTag('plugins:google-tag-manager')

export default defineNuxtPlugin({
  name: 'google-tag-manager',
  dependsOn: ['openfeature', 'assertive'],
  setup: async (nuxtApp) => {
    const { googleTagManagerId, redesignedNtpPaths } = useAppConfig()
    const { gtag, initialize } = useGtag()
    const route = useRoute()

    const { client } = await useOpenFeature()

    if (!googleTagManagerId) {
      logger.warn('Google Tag Manager: Gtag ID not available in app config')
      return
    }

    initialize(googleTagManagerId)

    // Maintain window.dataLayer field for legacy pages
    if (!import.meta.dev && !redesignedNtpPaths.includes(route.path)) {
      gtag('js', new Date())
      gtag('config', 'UA-62117061-22')
    }

    nuxtApp.hook('app:mounted', () => {
      try {
        const { $ayManagerEnv } = useNuxtApp()
        window.googletag = window.googletag || { cmd: [] }
        const disabledFallback = 'nofallback' in route.query

        window.googletag.cmd.push(() => {
          // Always set page-level targeting
          const cohortCookie = getCookieClient(COHORT_COOKIE)

          window.googletag.setConfig({
            targeting: {
              page_type: getPageType(),
              split_test_name: client.getStringValue(
                'splittestname',
                'default'
              ),
              cohort: cohortCookie ?? 'unknown',
              ay_version: String(
                $ayManagerEnv?.versionInfo?.versionId ?? 'unknown'
              ),
            },
          })

          // Conditionally add pubads event listener for native fallback
          if (disabledFallback) {
            logger.info('Native ad fallback disabled via query parameter')
            return
          }

          if (!window.googletag.pubads) {
            logger.error(
              'googletag.pubads() not available - cannot register native fallback listener'
            )
            return
          }

          window.googletag
            .pubads()
            .addEventListener('slotRenderEnded', setupNativeAdAsFallback)
        })
      } catch (err) {
        logger.error('Error mounting event listeners for native fallback', err)
      }
    })
  },
})
